import { useContext } from 'react'

import { Switch } from 'antd'
import { useSelector } from 'react-redux'

import { GlobalContext } from '../../Providers/GlobalProvider'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const DraftButton = () => {
  const { isDraft, setIsDraft } = useContext(GlobalContext)

  const t = useSelector(selectTranslate)

  return (
    <div
      className='simili-button ml-10'
      onClick={() => setIsDraft(!isDraft)}
    >
      {t('shifts_manager_header.draft_mode_toggle')} &nbsp;
      <Switch checked={isDraft} />
    </div>
  )
}

export default DraftButton
